function Pin({ color }) {
  return <div style={{ backgroundColor: color }} className="Pin"></div>
}

export default Pin;
